<template>
    <div>
        <div class="mb-5">
            <h1 class="display-heading">My Profile</h1>

            <div class="mb-3">
                <user-profile-common ref="userProfileForm" v-model="userProfile"></user-profile-common>
                <doctor-profile ref="doctorProfileForm" v-model="doctorProfile"></doctor-profile>
            </div>

            <div class="form-row">
                <div class="form-group">
                    <div class="mb-2 small text-danger">
                        * Required fields.
                    </div>
                </div>
            </div>

            <p v-show="isSubmitMessageShown" :class="{
                'text-danger': isSubmitMessageError
            }">
                {{submitMessage}}
            </p>

            <button type="button" class="btn btn-primary btn-primary-insv mr-2" @click="saveProfile">
                Save Changes
            </button>
            <button type="button" class="btn btn-secondary" @click="getProfile">Cancel Changes</button>
        </div>
        <div class="mb-5">
            <h5>Profile Photo</h5>
            <p>Upload your photo to our platform helps the patients to identify you better.</p>
            <div class="d-flex">
                <div class="mr-3">
                    <div class="doctor-profile">
                        <div v-if="!profilePhoto.pictureUrl" class="no-photo">No Photo</div>
                        <img v-else :src="`//${profilePhoto.pictureUrl}`">
                    </div>
                </div>
                <div class="flex-fill">
                    <form data-vv-scope="formUploadProfilePhoto" ref="formUploadProfilePhoto"
                        @submit.prevent="validateFormUploadProfilePic">
                        <div>
                            <div class="form-group">
                                <div>
                                    <input id="uploadFileInput" type="file" v-validate="'required|mimes:image/*'"
                                        data-vv-as="profile photo file" name="profilePhoto"
                                        :class="{'is-invalid':  validationErrors.has('profilePhoto')}">
                                    <div v-show="validationErrors.has('profilePhoto')" class="invalid-feedback">
                                        {{ validationErrors.first('profilePhoto') }}
                                    </div>
                                </div>
                            </div>

                            <p v-show="profilePhoto.isUploading" :class="{
                                'text-danger': profilePhoto.isUploadingError,
                                'mb-3': true
                            }">
                                {{profilePhoto.uploadMessage}}
                            </p>

                            <button class="btn btn-primary btn-primary-insv">Update Profile Photo</button>
                        </div>
                    </form>

                </div>
            </div>
        </div>
        <div class="card mb-5">
            <div class="card-header">
                Malaysian Medical Certificate Document <span class="text-primary" style="font-weight: bold;">(Optional)</span>
            </div>
            <div class="card-body">
                <p>Upload your MMC document here so that we could verify your identity.</p>

                <div class="mb-3">
                    <b>Uploaded Document</b>

                    <div v-if="!!mmcUpload.docFileNameGUID">
                        <p>{{mmcUpload.docOriFileName}}</p>
                        <div>
                            <a :href="`${doctorDocumentPath}${mmcUpload.docFileNameGUID}`"
                                class="btn btn-primary btn-primary-insv" target="_blank">Download Document</a>
                        </div>
                    </div>
                    <div v-else class="font-italic">None</div>
                </div>

                <div>
                    <b>Update Document</b>
                    <form data-vv-scope="formUploadMMC" ref="formUploadMMC"
                        @submit.prevent="validateFormUploadMMCDocument">
                        <div>
                            <div class="form-group">
                                <div>
                                    <input id="uploadMMCFileInput" type="file" v-validate="'required'"
                                        data-vv-as="MMC document" name="mmcDocument"
                                        :class="{'is-invalid':  validationErrors.has('formUploadMMC.mmcDocument')}">
                                    <div v-show="validationErrors.has('formUploadMMC.mmcDocument')" class="invalid-feedback">
                                        {{ validationErrors.first('formUploadMMC.mmcDocument') }}
                                    </div>
                                </div>
                            </div>

                            <p v-show="mmcUpload.isUploading" :class="{
                            'text-danger': mmcUpload.isUploadingError,
                            'mb-3': true
                        }">
                                {{mmcUpload.uploadMessage}}
                            </p>

                            <button class="btn btn-primary btn-primary-insv">Update Document</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="card mb-5">
            <div class="card-header">
                Annual Practitioner Certificate Document <span class="text-primary" style="font-weight: bold;">(Mandatory)</span>
            </div>
            <div class="card-body">
                <p>Upload your APC document here so that we could verify your identity.</p>
                <div class="mb-3">
                    <b>Uploaded Document</b>
                    <div v-if="!!apcUpload.docFileNameGUID">
                        <p>{{apcUpload.docOriFileName}}</p>
                        <div>
                            <a :href="`${doctorDocumentPath}${apcUpload.docFileNameGUID}`"
                                class="btn btn-primary btn-primary-insv" target="_blank">Download Document</a>
                        </div>
                    </div>
                    <div v-else class="font-italic">None</div>
                </div>

                <div>
                    <b>Update Document</b>
                    <form data-vv-scope="formUploadAPC" ref="formUploadAPC"
                        @submit.prevent="validateFormUploadAPCDocument">
                        <div>
                            <div class="form-group">
                                <div>
                                    <input id="uploadAPCFileInput" type="file" v-validate="'required'"
                                        data-vv-as="APC document" name="apcDocument"
                                        :class="{'is-invalid':  validationErrors.has('formUploadAPC.apcDocument')}">
                                    <div v-show="validationErrors.has('formUploadAPC.apcDocument')" class="invalid-feedback">
                                        {{ validationErrors.first('formUploadAPC.apcDocument') }}
                                    </div>
                                </div>
                            </div>

                            <p v-show="apcUpload.isUploading" :class="{
                            'text-danger': apcUpload.isUploadingError,
                            'mb-3': true
                        }">
                                {{apcUpload.uploadMessage}}
                            </p>

                            <button class="btn btn-primary btn-primary-insv">Update Document</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <!-- <div class="card mb-5">
            <div class="card-header">
                Borang B Document
            </div>
            <div class="card-body">
                <p>Upload your Borang B document here so that we could verify your identity.</p>
                <div class="mb-3">
                    <b>Uploaded Document</b>
                    <div v-if="!!borangBUpload.docFileNameGUID">
                        <p>{{borangBUpload.docOriFileName}}</p>
                        <div>
                            <a :href="`${doctorDocumentPath}${borangBUpload.docFileNameGUID}`"
                                class="btn btn-primary btn-primary-insv" target="_blank">Download Document</a>
                        </div>
                    </div>
                    <div v-else class="font-italic">None</div>
                </div>

                <div>
                    <b>Update Document</b>
                    <form data-vv-scope="formUploadBorangB" ref="formUploadBorangB"
                        @submit.prevent="validateFormUploadBorangDocument">
                        <div>
                            <div class="form-group">
                                <div>
                                    <input id="uploadBorangBFileInput" type="file" v-validate="'required'"
                                        data-vv-as="Borang B document" name="borangBDocument"
                                        :class="{'is-invalid':  validationErrors.has('formUploadBorangB.borangBDocument')}">
                                    <div v-show="validationErrors.has('formUploadBorangB.borangBDocument')" class="invalid-feedback">
                                        {{ validationErrors.first('formUploadBorangB.borangBDocument') }}
                                    </div>
                                </div>
                            </div>

                            <p v-show="borangBUpload.isUploading" :class="{
                            'text-danger': borangBUpload.isUploadingError,
                            'mb-3': true
                        }">
                                {{borangBUpload.uploadMessage}}
                            </p>

                            <button class="btn btn-primary btn-primary-insv">Update Document</button>
                        </div>
                    </form>
                </div>
            </div>
        </div> -->

        <div class="card">
            <div class="card-header">Bank Account Details</div>
            <div class="card-body">
                <form data-vv-scope="formBankAccountDetails" ref="formBankAccountDetails"
                    @submit.prevent="validateBankAccountDetailsForm">
                     <div class="form-group">
                        <label>Payee Name</label>
                        <input type="text" name="bankAccountPayeeName" data-vv-validate-on="blur" data-vv-as="bank payee name" placeholder="Bank Payee Name" v-model="bankAccount.bankAccountPayeeName" v-validate="'required'" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('bankAccountPayeeName')
                    }">
                        <div v-show="validationErrors.has('bankAccountPayeeName')" class="invalid-feedback">
                            {{ validationErrors.first('bankAccountPayeeName') }}
                        </div>
                    </div>

                    <div class="form-group">
                        <label>Bank Name</label>

                        <input type="text" name="bankName" data-vv-validate-on="blur" data-vv-as="bank name"
                            placeholder="Bank Name" v-model="bankAccount.bankName" v-validate="'required'" :class="{
                    'form-control': true,
                    'is-invalid':  validationErrors.has('formBankAccountDetails.bankName')
                }">
                        <div v-show="validationErrors.has('formBankAccountDetails.bankName')" class="invalid-feedback">
                            {{ validationErrors.first('formBankAccountDetails.bankName') }}
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Bank Account Number</label>

                        <input type="text" name="accountNumber" data-vv-validate-on="blur"
                            data-vv-as="bank account number" placeholder="Bank Account Number" v-model="bankAccount.accountNumber"
                            v-validate="'required'" :class="{
                    'form-control': true,
                    'is-invalid':  validationErrors.has('formBankAccountDetails.accountNumber')
                }">
                        <div v-show="validationErrors.has('formBankAccountDetails.accountNumber')" class="invalid-feedback">
                            {{ validationErrors.first('formBankAccountDetails.accountNumber') }}
                        </div>
                    </div>

                    <p v-if="bankAccount.isSaving" :class="{
                        'text-danger': bankAccount.isSavingError
                    }">
                        {{bankAccount.saveMessage}}
                    </p>
                    <button class="btn btn-primary btn-primary-insv">Save Bank Account Details</button>
                </form>
            </div>
        </div>

        <popup-modal ref="popupCompleteProfile" :hasCloseButton="false" title="Complete your Profile">
            <template slot="content">
                <p>Please complete your profile before proceeding with other actions.</p>
                <p>Thank you.</p>
            </template>
            <template slot="footer">
                <button type="button" class="btn btn-primary btn-primary-insv" @click="dismissPopupCompleteProfile">Okay</button>
            </template>
        </popup-modal>
    </div>
</template>

<script>
import {
    apiPath
} from '@/config';
import {
    convertDateToDDMMYYYY,
    convertDateToIso8601
} from '@/utilities';
import userProfileCommon from '@/components/user-profile';
import doctorProfile from '@/components/user-profile/doctor';
import popupModal from '@/components/popup-modal';
export default {
    'name': 'DoctorProfile',
    'components': {
        userProfileCommon,
        doctorProfile,
        popupModal
    },
    'data': function () {
        return {
            'userProfile': {
                'name': null,
                'designation': null,
                'designationChoice': 'Mr.',
                'gender': 0,
                'birthDate': null,
                'email': null,
                'phoneNo': null,
                'identitifcationType': 0,
                'identificationNumber': null
            },
            'doctorProfile': {
                'registrationNumber': null,
                'languagesSpeak': [],
                // 'specialtyId': null,
                'specialtyIds': [],
                'affiliation': null,
                'yearsPracticing': null,
                'education': null,
                'apcNumber': null,
                'apcExpiry': null,
                'location': null
                // 'borangBNumber': null
            },
            'isSubmitMessageShown': false,
            'isSubmitMessageError': false,
            'submitMessage': '',
            'profilePhoto': {
                'pictureUrl': '',
                'isUploading': false,
                'isUploadingError': false,
                'uploadMessage': ''
            },
            'mmcUpload': {
                'docFileNameGUID': '',
                'docOriFileName': '',
                'isUploading': false,
                'isUploadingError': false,
                'uploadMessage': ''
            },
            'apcUpload': {
                'docFileNameGUID': '',
                'docOriFileName': '',
                'isUploading': false,
                'isUploadingError': false,
                'uploadMessage': ''
            },
            // 'borangBUpload': {
            //     'docFileNameGUID': '',
            //     'docOriFileName': '',
            //     'isUploading': false,
            //     'isUploadingError': false,
            //     'uploadMessage': ''
            // },
            'doctorDocumentPath': `${apiPath}Profile/DoctorDocument?fileName=`,
            'bankAccount': {
                'bankAccountPayeeName': '',
                'bankName': '',
                'accountNumber': '',
                'isSaving': false,
                'isSavingError': false,
                'saveMessage': ''
            }
        };
    },
    mounted () {
        this.getProfile();

        this.$nextTick(() => {
            if (this.$store.state.user.isProfileCompleted === 0) {
                this.$refs.popupCompleteProfile.show();
            }
        });
    },
    'methods': {
        formatCommaPayload (array) {
            let string = '';
            for (const [index, element] of array.entries()) {
                string = string + element;

                if (index !== array.length - 1) {
                    string = string + ',';
                }
            }

            return string;
        },
        getProfile () {
            this.isSubmitMessageShown = false;
            this.$refs.userProfileForm.clearValidation();
            this.$refs.doctorProfileForm.clearValidation();
            this.axios.get('Profile/GetUserProfile').then(({
                data
            }) => {
                let profileData = data.data;
                this.userProfile.name = profileData.f;
                this.userProfile.designationChoice = profileData.d;
                this.userProfile.email = profileData.e;
                this.userProfile.identitifcationType = profileData.ict;
                this.userProfile.identificationNumber = profileData.ic;
                this.userProfile.birthDate = convertDateToDDMMYYYY(profileData.bd);
                this.userProfile.gender = profileData.g;
                this.userProfile.phoneNo = profileData.p;

                let doctorProfile = profileData.dp;
                this.doctorProfile.registrationNumber = doctorProfile.rn;
                // this.doctorProfile.specialtyId = doctorProfile.si;
                this.doctorProfile.specialtyIds = doctorProfile.ds.map(ds => ds.si);
                this.doctorProfile.languagesSpeak = doctorProfile.l ? doctorProfile.l.split(',') : [];
                this.doctorProfile.affiliation = doctorProfile.dhca;
                this.doctorProfile.yearsPracticing = doctorProfile.yp;
                this.doctorProfile.education = doctorProfile.edu;
                this.doctorProfile.apcNumber = doctorProfile.apc;
                // this.doctorProfile.borangBNumber = doctorProfile.bbn;
                // this.doctorProfile.apcExpiry = convertDateToDDMMYYYY(doctorProfile.apce);
                this.doctorProfile.location = doctorProfile.loc;

                this.profilePhoto.pictureUrl = profileData.piu;

                if (doctorProfile.dmc) {
                    this.mmcUpload.docFileNameGUID = doctorProfile.dmc.fg;
                    this.mmcUpload.docOriFileName = doctorProfile.dmc.fn;
                }

                if (doctorProfile.dac) {
                    this.apcUpload.docFileNameGUID = doctorProfile.dac.fg;
                    this.apcUpload.docOriFileName = doctorProfile.dac.fn;
                }

                // if (doctorProfile.dbb) {
                //     this.borangBUpload.docFileNameGUID = doctorProfile.dbb.fg;
                //     this.borangBUpload.docOriFileName = doctorProfile.dbb.fn;
                // }

                this.bankAccount.bankAccountPayeeName = doctorProfile.bap;
                this.bankAccount.bankName = doctorProfile.bn;
                this.bankAccount.accountNumber = doctorProfile.ba;
            }).catch(() => {});
        },
        saveProfile () {
            this.isSubmitMessageShown = true;
            this.isSubmitMessageError = false;
            Promise.all([this.$refs.userProfileForm.validateForm(), this.$refs.doctorProfileForm.validateForm()])
                .then(
                    (validationResults) => {
                        this.$nextTick(() => {
                            if (validationResults.filter(v => v === false).length > 0) {
                                // focus to the first error
                                document.body.querySelector('.is-invalid').focus();

                                this.isSubmitMessageError = true;
                                this.submitMessage =
                                        'You have error in the form. Please check your input(s) before saving your profile.';
                            } else {
                                this.submitMessage = 'Saving profile...';

                                let doctorSpecialties = this.doctorProfile.specialtyIds.map((s) => {
                                    return {
                                        'si': s
                                    };
                                });

                                if (this.userProfile.designationChoice !== -1) {
                                    this.userProfile.designation = this.userProfile.designationChoice;
                                }
                                this.axios.post('Profile/UpdateUserProfile', {
                                    'f': this.userProfile.name,
                                    'd': this.userProfile.designation,
                                    'e': this.userProfile.email,
                                    'ict': this.userProfile.identitifcationType,
                                    'ic': this.userProfile.identificationNumber,
                                    'bd': convertDateToIso8601(this.userProfile.birthDate),
                                    'g': this.userProfile.gender,
                                    'p': this.userProfile.phoneNo,
                                    'dp': {
                                        'rn': this.doctorProfile.registrationNumber,
                                        // 'si': this.doctorProfile.specialtyId,
                                        'ds': doctorSpecialties,
                                        'l': this.formatCommaPayload(this.doctorProfile.languagesSpeak),
                                        'dhca': this.doctorProfile.affiliation,
                                        'yp': this.doctorProfile.yearsPracticing,
                                        'edu': this.doctorProfile.education,
                                        'apc': this.doctorProfile.apcNumber,
                                        // 'apce': convertDateToIso8601(this.doctorProfile.apcExpiry),
                                        'loc': this.doctorProfile.location
                                    }
                                }).then(() => {
                                    this.submitMessage = 'Successfully updated profile! Your information is saved and encrypted.';
                                    this.$store.commit('completedProfile');
                                }).catch((error) => {
                                    this.isSubmitMessageError = true;
                                    if (error.response.data) {
                                        this.submitMessage = error.response.data.message;
                                    } else {
                                        this.submitMessage =
                                                'Error saving profile. Please try again.';
                                    }
                                });
                            }
                        });
                    });
        },
        validateFormUploadProfilePic () {
            this.profilePhoto.isUploading = true;
            this.profilePhoto.isUploadingError = false;
            this.$validator.validateAll('formUploadProfilePhoto').then((isValidate) => {
                if (isValidate) {
                    let profilePictureFile = document.querySelector('#uploadFileInput');
                    let formData = new FormData();
                    formData.append('ProfilePhotoFile', profilePictureFile.files[0]);
                    this.profilePhoto.uploadMessage = 'Uploading profile photo file...';

                    this.axios.post('Profile/DoctorUpdateProfilePhoto', formData, {
                        'headers': {
                            'Content-Type': 'multipart/form-data'
                        }
                    }).then(({
                        data
                    }) => {
                        this.$refs.formUploadProfilePhoto.reset();
                        if (data.data.piu) {
                            this.profilePhoto.uploadMessage = 'Profile photo updated successfully!';
                            this.profilePhoto.pictureUrl = data.data.piu;
                        } else {
                            this.profilePhoto.isUploadingError = true;
                            this.profilePhoto.uploadMessage = data.data.e;
                        }
                    }).catch((error) => {
                        this.profilePhoto.isUploadingError = true;
                        if (error && error.response && error.response.data) {
                            this.profilePhoto.uploadMessage = error.response.data.message;
                        } else {
                            this.profilePhoto.uploadMessage =
                                    'Error processing profile photo upload. Please try again.';
                        }
                    });
                } else {
                    this.profilePhoto.isUploadingError = true;
                    this.profilePhoto.uploadMessage =
                            'You have error in the form. Please check your input(s) before saving your profile photo.';
                }
            });
        },
        validateFormUploadMMCDocument () {
            this.mmcUpload.isUploading = true;
            this.mmcUpload.isUploadingError = false;
            this.$validator.validateAll('formUploadMMC').then((isValidate) => {
                if (isValidate) {
                    let documentUploadFile = document.querySelector('#uploadMMCFileInput');
                    let formData = new FormData();
                    formData.append('CertificationFile', documentUploadFile.files[0]);
                    formData.append('DoctorCertType', 1);
                    this.mmcUpload.uploadMessage = 'Uploading MMC document file...';

                    this.axios.post('Profile/DoctorUploadDocument', formData, {
                        'headers': {
                            'Content-Type': 'multipart/form-data'
                        }
                    }).then(({
                        data
                    }) => {
                        this.$refs.formUploadMMC.reset();
                        if (data.data && data.data.fg) {
                            this.mmcUpload.uploadMessage = 'MMC document updated successfully!';
                            this.mmcUpload.docFileNameGUID = data.data.fg;
                            this.mmcUpload.docOriFileName = data.data.fn;
                        } else {
                            this.mmcUpload.isUploadingError = true;
                            this.mmcUpload.uploadMessage = data.data.e;
                        }
                    }).catch((error) => {
                        this.mmcUpload.isUploadingError = true;
                        if (error && error.response && error.response.data) {
                            this.mmcUpload.uploadMessage = error.response.data.message;
                        } else {
                            this.mmcUpload.uploadMessage =
                                    'Error processing MMC document upload. Please try again.';
                        }
                    });
                } else {
                    this.mmcUpload.isUploadingError = true;
                    this.mmcUpload.uploadMessage =
                            'You have error in the form. Please check your input(s) before saving your MMC document.';
                }
            });
        },
        validateFormUploadAPCDocument () {
            this.apcUpload.isUploading = true;
            this.apcUpload.isUploadingError = false;
            this.$validator.validateAll('formUploadAPC').then((isValidate) => {
                if (isValidate) {
                    let documentUploadFile = document.querySelector('#uploadAPCFileInput');
                    let formData = new FormData();
                    formData.append('CertificationFile', documentUploadFile.files[0]);
                    formData.append('DoctorCertType', 2);

                    this.apcUpload.uploadMessage = 'Uploading APC document file...';

                    this.axios.post('Profile/DoctorUploadDocument', formData, {
                        'headers': {
                            'Content-Type': 'multipart/form-data'
                        }
                    }).then(({
                        data
                    }) => {
                        this.$refs.formUploadAPC.reset();
                        if (data.data && data.data.fg) {
                            this.apcUpload.uploadMessage = 'APC document updated successfully!';
                            this.apcUpload.docFileNameGUID = data.data.fg;
                            this.apcUpload.docOriFileName = data.data.fn;
                        } else {
                            this.apcUpload.isUploadingError = true;
                            this.apcUpload.uploadMessage = data.data.e;
                        }
                    }).catch((error) => {
                        this.apcUpload.isUploadingError = true;
                        if (error && error.response && error.response.data) {
                            this.apcUpload.uploadMessage = error.response.data.message;
                        } else {
                            this.apcUpload.uploadMessage =
                                    'Error processing APC document upload. Please try again.';
                        }
                    });
                } else {
                    this.apcUpload.isUploadingError = true;
                    this.apcUpload.uploadMessage =
                            'You have error in the form. Please check your input(s) before saving your APC document.';
                }
            });
        },
        // validateFormUploadBorangDocument () {
        //     this.borangBUpload.isUploading = true;
        //     this.borangBUpload.isUploadingError = false;
        //     this.$validator.validateAll('formUploadBorangB').then((isValidate) => {
        //         if (isValidate) {
        //             let documentUploadFile = document.querySelector('#uploadBorangBFileInput');
        //             let formData = new FormData();
        //             formData.append('CertificationFile', documentUploadFile.files[0]);
        //             formData.append('DoctorCertType', 3);

        //             this.borangBUpload.uploadMessage = 'Uploading Borang B document file...';

        //             this.axios.post('Profile/DoctorUploadDocument', formData, {
        //                 'headers': {
        //                     'Content-Type': 'multipart/form-data'
        //                 }
        //             }).then(({
        //                 data
        //             }) => {
        //                 this.$refs.formUploadBorangB.reset();
        //                 if (data.data && data.data.fg) {
        //                     this.borangBUpload.uploadMessage = 'Borang B document updated successfully!';
        //                     this.borangBUpload.docFileNameGUID = data.data.fg;
        //                     this.borangBUpload.docOriFileName = data.data.fn;
        //                 } else {
        //                     this.borangBUpload.isUploadingError = true;
        //                     this.borangBUpload.uploadMessage = data.data.e;
        //                 }
        //             }).catch((error) => {
        //                 this.borangBUpload.isUploadingError = true;
        //                 if (error && error.response && error.response.data) {
        //                     this.borangBUpload.uploadMessage = error.response.data.message;
        //                 } else {
        //                     this.borangBUpload.uploadMessage =
        //                             'Error processing Borang B document upload. Please try again.';
        //                 }
        //             });
        //         } else {
        //             this.borangBUpload.isUploadingError = true;
        //             this.borangBUpload.uploadMessage =
        //                     'You have error in the form. Please check your input(s) before saving your Borang B document.';
        //         }
        //     });
        // },
        validateBankAccountDetailsForm () {
            this.$validator.validateAll('formBankAccountDetails').then((isValidate) => {
                if (isValidate) {
                    this.bankAccount.isSaving = true;
                    this.bankAccount.saveMessage = 'Saving bank account details...';

                    this.axios.post('Profile/DoctorUpdateBankAccount', {
                        'bap': this.bankAccount.bankAccountPayeeName,
                        'bn': this.bankAccount.bankName,
                        'ba': this.bankAccount.accountNumber
                    }).then(({ data }) => {
                        this.bankAccount.saveMessage = 'Bank account details updated!';
                    }).catch((error) => {
                        this.bankAccount.isSavingError = true;

                        if (error.response.data) {
                            this.bankAccount.saveMessage = error.response.data.message;
                        } else {
                            this.bankAccount.saveMessage = 'Error saving bank account details. Please try again.';
                        }
                    });
                }
            });
        },
        dismissPopupCompleteProfile () {
            this.$refs.popupCompleteProfile.hide();
        }
    }
};

</script>

<style>
    .doctor-profile {
        width: 150px;
        height: 150px;
        border: 1px solid #ccc;
        background-color: #eee;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .doctor-profile .no-photo {
        font-size: 24px;
    }

    .doctor-profile img {
        max-width: 100%;
        max-height: 100%;
    }

</style>
